import { createContext, useContext } from "react";
export const RouterContext = createContext(null);
export const useRouter = () => {
    const context = useContext(RouterContext);
    if (!context) {
        throw new Error("useRouter must be used within a RouterContext.Provider");
    }
    return context;
};
